<template>
  <div class="about">
    <v-alert type="success">
      I'm a success alert.
    </v-alert>
    <v-btn @click="handleClick" >Normal Button</v-btn>
  </div>
</template>

<script>
  import {errorNotify} from '@/utils/alertutil'

  export default {
    name: 'About',
    methods:{
      handleClick(){
        loginByUsername().then(res => console.log(res))
          .catch(err => console.log(err))
      }
    }
  }
</script>